export const GUN_TYPE = {
    PISTOL: 'PISTOL',
    AK47: 'AK47',
    GUN: 'GUN',
}

export const UNIT_TYPE = {
    'USER': 'USER',
    'UNIT': 'UNIT'
}

export const ENEMY_TYPE = {
    PISTOL: 'PISTOL',
    AK47: 'AK47',
    GUN: 'GUN',
}

export const INTERACTION_TYPE = {
    ADD_BLOCK: 'ADD_BLOCK',
    ADD_ENEMY: 'ADD_ENEMY',
    ADD_USER_POSITION: 'ADD_USER_POSITION',
}